<script setup lang="ts">
import UIBanner from '@/components/ui/UIBanner.vue'
import { PhCheckCircle } from '@phosphor-icons/vue'

defineProps<{
  /** What text should be displayed in the banner? */
  bannerText: string
}>()
</script>

<template>
  <UIBanner variant="success" data-testid="success-banner">
    <div class="flex items-center space-x-[10px]">
      <PhCheckCircle
        size="24"
        class="fill-white shrink-0"
        weight="fill"
        aria-hidden="true"
      />
      <p class="text-left pointer-events-auto">
        {{ bannerText }}
      </p>
    </div>
  </UIBanner>
</template>
